import { BrowserRouter as Router } from "react-router-dom";
import { CaseProvider } from "./context/CaseContext";
import AppRoutes from "./routes/AppRoutes";
import { ToastProvider } from "./context/ToastContext";
import { AuthProvider } from "./context/AuthContext";
import InactivityHandler from "./utils/InactivityHandler";

const App = () => {
  return (
    <AuthProvider>
      <ToastProvider>
        <InactivityHandler />
        <CaseProvider>
          <Router>
            <AppRoutes />
          </Router>
        </CaseProvider>
      </ToastProvider>
    </AuthProvider>
  );
};

export default App;
